import * as React from 'react';
import type { FreshnessState } from '../domain/models.js';
import { phoneFreshnessLabel } from '../domain/freshness.js';
import { InfoIcon } from './Icons.js';

interface StatusBadgeProps {
  state: FreshnessState;
  label: string;
  detail: string;
  compact?: boolean;
  phoneCompact?: boolean;
  testId?: string;
}

export function StatusBadge({
  state,
  label,
  detail,
  compact = false,
  phoneCompact = false,
  testId,
}: StatusBadgeProps) {
  const [open, setOpen] = React.useState(false);
  const popoverId = `status-${(testId ?? label).replace(/[^a-zA-Z0-9а-яА-Я]/g, '-')}`;
  return (
    <span className={`status-control status-${state}`} data-testid={testId} data-full-status={label}>
      <button
        type="button"
        className={compact ? 'status-badge compact' : 'status-badge'}
        aria-label={`${label}. Показать подробности свежести`}
        aria-expanded={open}
        aria-controls={popoverId}
        onClick={() => setOpen((current) => !current)}
      >
        <span className="status-dot" aria-hidden="true" />
        <span className={phoneCompact ? 'status-label-full has-phone-compact' : 'status-label-full'}>{label}</span>
        {phoneCompact ? <span className="status-label-phone" aria-hidden="true">{phoneFreshnessLabel(state)}</span> : null}
        <InfoIcon />
      </button>
      {open ? (
        <span id={popoverId} role="tooltip" className="status-popover" data-testid={`${testId ?? 'status'}-detail`}>
          <strong>{label}</strong>
          <span>{detail}</span>
        </span>
      ) : null}
    </span>
  );
}
